module.exports = __webpack_public_path__ + "static/img/guias.0bdb28a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loja/guias.png
// module id = 835
// module chunks = 0